/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BiomarkerOcrRequestResponseDto
 */
export interface BiomarkerOcrRequestResponseDto {
    /**
     * OCR request ID
     * @type {string}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    id: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    patientId: string;
    /**
     * File path that was processed
     * @type {string}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    filePath: string;
    /**
     * Current processing status
     * @type {string}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    status: BiomarkerOcrRequestResponseDtoStatusEnum;
    /**
     * When processing started
     * @type {Date}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    startedAt?: Date;
    /**
     * When processing completed
     * @type {Date}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    completedAt?: Date;
    /**
     * Total number of biomarkers extracted from OCR
     * @type {number}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    totalExtracted?: number;
    /**
     * Total number of biomarkers successfully saved
     * @type {number}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    totalSaved?: number;
    /**
     * Error message if processing failed
     * @type {string}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    errorMessage?: string;
    /**
     * Additional processing metadata
     * @type {object}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    metadata?: object;
    /**
     * When the request was created
     * @type {Date}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    createdAt: Date;
    /**
     * When the request was last updated
     * @type {Date}
     * @memberof BiomarkerOcrRequestResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const BiomarkerOcrRequestResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;
export type BiomarkerOcrRequestResponseDtoStatusEnum = typeof BiomarkerOcrRequestResponseDtoStatusEnum[keyof typeof BiomarkerOcrRequestResponseDtoStatusEnum];


/**
 * Check if a given object implements the BiomarkerOcrRequestResponseDto interface.
 */
export function instanceOfBiomarkerOcrRequestResponseDto(value: object): value is BiomarkerOcrRequestResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('filePath' in value) || value['filePath'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function BiomarkerOcrRequestResponseDtoFromJSON(json: any): BiomarkerOcrRequestResponseDto {
    return BiomarkerOcrRequestResponseDtoFromJSONTyped(json, false);
}

export function BiomarkerOcrRequestResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BiomarkerOcrRequestResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'filePath': json['filePath'],
        'status': json['status'],
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'totalExtracted': json['totalExtracted'] == null ? undefined : json['totalExtracted'],
        'totalSaved': json['totalSaved'] == null ? undefined : json['totalSaved'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function BiomarkerOcrRequestResponseDtoToJSON(json: any): BiomarkerOcrRequestResponseDto {
    return BiomarkerOcrRequestResponseDtoToJSONTyped(json, false);
}

export function BiomarkerOcrRequestResponseDtoToJSONTyped(value?: BiomarkerOcrRequestResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'filePath': value['filePath'],
        'status': value['status'],
        'startedAt': value['startedAt'] == null ? undefined : ((value['startedAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'totalExtracted': value['totalExtracted'],
        'totalSaved': value['totalSaved'],
        'errorMessage': value['errorMessage'],
        'metadata': value['metadata'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

